<template>
  <div class="product" style="background:#fff">
    <div class="pro-head content flex-center">
      <div class="content-item content-item-pc content-item-mb flex-space-between">
        <div class="con-info">
          <p>弱电智能化一站式服务</p>
          <p>打通弱电各个系统信息壁垒，实现人与建筑的智慧生态融合。</p>
        </div>
        <img class="con-img" src="../../assets/login.gif"/>
      </div>
    </div>
    <p class="app-title" style="padding:60px 0">
      代理品牌
    </p>
    <div class="pro-content" style="position:relative">
      <div class="pro-cont-one">
        <div class="content-item flex-space-between">
          <div class="pro-con-info">
            <p>弱电系统集成品牌</p>
            <p>综合布线，组网，安防，监控，IBMS，机房，音视频等</p>
          </div>
          <img class="pro-con-img" src="../../assets/system.png"/>
        </div>
      </div>
      <div class="pro-cont-two" style="">
        <div class="content-item flex-space-between"
             style="border-bottom: 1px solid rgba(255,255,255,0.5);">
          <img class="pro-con-img" src="../../assets/building.png"/>
          <div class="pro-con-info ta">
            <p>建筑智能化品牌</p>
            <p>楼宇自控，能耗监测，智能照明，智能机电等</p>
          </div>
        </div>
      </div>
      <div class="pro-cont-three" style="">
        <div class="content-item flex-space-between"
             style="border-bottom: 1px solid rgba(255,255,255,0.5);">
          <div class="pro-con-info">
            <p>智能化软件品牌</p>
            <p>三维可视，业务软件，BIM平台总控等</p>
          </div>
          <img class="pro-con-img" src="../../assets/software.png"/>
        </div>
      </div>
    </div>

    <p class="app-title widddd" style="padding:60px 0;">
      特色服务
    </p>
    <div class="pro-content advantage-border pro-advantage">
      <div class="content-item advantage-item flex-center">
        <div class="pro-adv-info">
          <span>成本优势</span>
        </div>
        <img class="pro-adv-img" src="../../assets/price.png"/>
      </div>
      <div class="content-item advantage-border advantage-item flex-center" style="border-bottom: 1px solid rgba(255,255,255,0.5);">
        <img class="pro-adv-img" src="../../assets/store.png"/>
        <div class="pro-adv-info adv-ta">
          <span>品类优势</span>
        </div>
      </div>
      <div class="content-item advantage-border advantage-item flex-center" style="border-bottom: 1px solid rgba(255,255,255,0.5);">
        <div class="pro-adv-info">
          <span>技术优势</span>
        </div>
        <img class="pro-adv-img" src="../../assets/solution.png"/>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "wk_product",
    }
</script>

<style scoped>
  @import "../../style.css";
  @import "wk_product_pc.css";
  @import "wk_product_mini.css";
</style>



// WEBPACK FOOTER //
// src/components/wk_product/wk_product.vue